/**
 * @generated SignedSource<<89aa9f4566f635f3b20667215d330f20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RemoveContactFromListInput = {
  contactIdentifier: string;
  mailingListIdentifier: string;
};
export type RemoveContactFromListDialogMutation$variables = {
  input: RemoveContactFromListInput;
};
export type RemoveContactFromListDialogMutation$data = {
  readonly removeContactFromList: {
    readonly id: string;
    readonly subscribedCount: number;
  };
};
export type RemoveContactFromListDialogMutation = {
  response: RemoveContactFromListDialogMutation$data;
  variables: RemoveContactFromListDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MailingList",
    "kind": "LinkedField",
    "name": "removeContactFromList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subscribedCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveContactFromListDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveContactFromListDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "38ae4fd739d1e3a20d0fd81c6b7a9381",
    "id": null,
    "metadata": {},
    "name": "RemoveContactFromListDialogMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveContactFromListDialogMutation(\n  $input: RemoveContactFromListInput!\n) {\n  removeContactFromList(input: $input) {\n    id\n    subscribedCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "a5f1547d0e2f654f8187bb9e9e555561";

export default node;
